(() => {
  const dialog = document.querySelector('[data-search-dialog]');
  if (!dialog) return;
  const input = dialog.querySelector('[data-search-input]');
  const results = dialog.querySelector('[data-search-results]');
  const count = dialog.querySelector('[data-search-count]');
  const all = dialog.querySelector('[data-search-all]');
  const featured = results.innerHTML;
  const root = window.Shopify?.routes?.root || '/';
  let products = [];
  let controller;
  let debounce;
  const escape = (value) => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style:'currency',currency:document.body.dataset.currency || 'INR',maximumFractionDigits:0}).format(cents / 100);
  const selectedPet = () => dialog.querySelector('[data-pet-filter].is-active')?.dataset.petFilter || 'all';
  const card = product => {
    const image = product.featured_image?.url || product.featured_image || product.image || '';
    const url = product.url || `/products/${encodeURIComponent(product.handle || '')}`;
    const title = escape(product.title);
    const price = Number(product.price || product.variants?.[0]?.price || 0);
    const variant = product.variants?.find(v => v.available) || product.variants?.[0];
    return `<article class="paw-search-product" data-pet-text="${escape([product.title,product.product_type,product.tags?.join?.(' ') || ''].join(' ').toLowerCase())}"><a class="paw-search-product__image" href="${escape(url)}">${image ? `<img src="${escape(image)}" alt="${title}" width="90" height="90" loading="lazy">` : ''}</a><div class="paw-search-product__body"><small>${escape(product.product_type || 'Pet essentials')}</small><a href="${escape(url)}"><strong>${title}</strong></a><p>${escape((product.body || '').replace(/<[^>]*>/g,'').slice(0,65))}</p><div class="paw-search-product__bottom"><b>${money(price * 100)}</b><a href="${escape(url)}">Details →</a><button type="button" data-search-add="${escape(product.handle)}" data-product-url="${escape(url)}">Add to Cart</button></div></div></article>`;
  };
  const filter = () => {
    const pet = selectedPet();
    results.querySelectorAll('.paw-search-empty').forEach(el => el.remove());
    results.querySelectorAll('[data-pet-text]').forEach(el => {
      el.hidden = pet !== 'all' && !el.dataset.petText.includes(pet);
    });
    const visible = results.querySelectorAll('[data-pet-text]:not([hidden])').length;
    count.textContent = `${visible} products`;
    if (!visible) results.innerHTML += '<p class="paw-search-empty">No matching products. Try another search or pet filter.</p>';
  };
  const search = async () => {
    const q = input.value.trim();
    all.href = q ? `${dialog.dataset.searchPage}?type=product&q=${encodeURIComponent(q)}` : `${root}collections/all`;
    if (!q) { controller?.abort(); results.innerHTML = featured; filter(); return; }
    controller?.abort();
    controller = new AbortController();
    count.textContent = 'Searching…';
    try {
      const url = new URL(`${root}search/suggest.json`, location.origin);
      url.searchParams.set('q', q);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '10');
      url.searchParams.set('resources[options][unavailable_products]', 'hide');
      const response = await fetch(url, {signal:controller.signal});
      if (!response.ok) throw new Error('Search unavailable');
      products = (await response.json()).resources?.results?.products || [];
      results.innerHTML = products.map(card).join('');
      if (!products.length) results.innerHTML = '<p class="paw-search-empty">No products found. Try another search.</p>';
      filter();
    } catch (error) {
      if (error.name !== 'AbortError') { results.innerHTML = '<p class="paw-search-empty">Search is unavailable. Use “View all search results” below.</p>'; count.textContent = ''; }
    }
  };
  document.querySelectorAll('[data-search-open]').forEach(button => button.addEventListener('click', () => {
    document.querySelector('[data-mobile-menu-close]')?.click();
    if (!dialog.open) dialog.showModal();
    document.body.classList.add('paw-search-open');
    results.innerHTML = featured;
    filter();
    input.focus();
  }));
  dialog.querySelector('[data-search-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => document.body.classList.remove('paw-search-open'));
  input.addEventListener('input', () => { clearTimeout(debounce); debounce = setTimeout(search, 220); });
  dialog.querySelectorAll('[data-search-term]').forEach(button => button.addEventListener('click', () => { input.value = button.dataset.searchTerm; input.focus(); search(); }));
  results.addEventListener('click', async event => {
    const button = event.target.closest('[data-search-add]');
    if (!button) return;
    button.disabled = true;
    try {
      const response = await fetch(`${root}products/${encodeURIComponent(button.dataset.searchAdd)}.js`);
      if (!response.ok) throw new Error('Product unavailable');
      const product = await response.json();
      const available = product.variants.filter(variant => variant.available);
      if (product.variants.length > 1 || !available.length) { location.href = button.dataset.productUrl; return; }
      const form = document.createElement('form');
      form.dataset.productForm = '';
      form.innerHTML = `<input type="hidden" name="id" value="${escape(available[0].id)}"><button type="submit">Add to Cart</button>`;
      button.replaceWith(form);
      form.requestSubmit();
    } catch (_) { button.disabled = false; button.textContent = 'View options'; }
  });
  dialog.querySelectorAll('[data-pet-filter]').forEach(button => button.addEventListener('click', () => {
    dialog.querySelectorAll('[data-pet-filter]').forEach(el => {el.classList.toggle('is-active', el === button);el.setAttribute('aria-pressed', el === button ? 'true' : 'false');});
    results.innerHTML = input.value.trim() ? products.map(card).join('') : featured;
    filter();
  }));
  document.addEventListener('keydown', event => {
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {event.preventDefault();if (!dialog.open) dialog.showModal();input.focus();}
    if (event.key === 'Escape' && dialog.open) dialog.close();
  });
  document.querySelectorAll('[data-nav-toggle]').forEach(button => button.addEventListener('click', () => {
    const parent = button.closest('[data-nav-item]');
    document.querySelectorAll('[data-nav-item]').forEach(item => { if (item !== parent) {item.classList.remove('is-expanded');item.querySelector('[data-nav-toggle]')?.setAttribute('aria-expanded','false');} });
    const expanded = parent.classList.toggle('is-expanded');
    button.setAttribute('aria-expanded', String(expanded));
  }));
  document.addEventListener('click', event => {if (!event.target.closest('[data-nav-item]')) document.querySelectorAll('[data-nav-item].is-expanded').forEach(item => {item.classList.remove('is-expanded');item.querySelector('[data-nav-toggle]')?.setAttribute('aria-expanded','false');});});
})();
